<template>
  <div class="cencent">

    <div style="height: 200px">

    </div>

    <div class="login_box">


      <div style="padding: 10px">

        <el-form ref="form" :model="form" label-width="80px">
          <el-form-item label="手机号">
            <el-input v-model="form.phone" clearable maxlength="11" style="width: 80%"></el-input>
          </el-form-item>

          <el-form-item label="验证码">
            <div style="display: flex;justify-content: space-between">
              <div style="width: 80%">
                <el-input v-model="form.code" maxlength="6"></el-input>
              </div>
              <div style="color:#409eff;text-align: center;width: 20%;cursor: pointer" @click="get_code()">
                {{ codemsg }}
              </div>
            </div>
          </el-form-item>
          <el-form-item>
            <div style="height: 20px">

            </div>
            <el-button style="width: 240px" type="primary" @click="login"> 登录</el-button>
          </el-form-item>
        </el-form>
      </div>


    </div>

  </div>
</template>

<script>
import u from "../../../assets/js/util"

export default {
  name: "index",
  data() {
    return {
      codemsg: "获取",
      form: {
        phone: "",
        code: ""
      }
    }
  },
  methods: {

    async login() {
      if (!u.isPhone(this.form.phone)) {
        u.error("手机号格式不正确")
        return;
      }
      if (!this.form.code) {
        u.error("验证码不能空")
        return;
      }
      var data = await u.post("users", "getcode_admin_login", {phone: this.form.phone, code: this.form.code})

      if (data !== false) {

        document.cookie = "AUTH=" + data

        this.$router.push('/adminhome')

      }
    },
    async get_code() {
      if (!u.isPhone(this.form.phone)) {
        u.error("手机号格式不正确")
        return;
      }

      if (this.codemsg != "获取") {
        return
      }
      this.codemsg = 60
      var stl = setInterval(() => {
        this.codemsg = this.codemsg - 1

        if (this.codemsg <= 0) {
          this.codemsg = "获取"
          clearInterval(stl)
        }
      }, 1000)
      var data = await u.post("users", "getcode_admin", {phone: this.form.phone, temp: "640013"})
      if (data === false) {
        u.error("获取失败")
        clearInterval(stl)
        this.codemsg = "获取"
        return
      }
    }
  }
}
</script>

<style scoped>

.login_box {
  width: 400px;
  height: 600px;
  background-color: #fff;
  margin: 0 auto;
  margin-top: 100px;
  border-radius: 10px;
}


</style>



// WEBPACK FOOTER //
// src/page/module/admin/login.vue